// extracted by mini-css-extract-plugin
export default {"EstimatedFare":"EstimatedFarePage_EstimatedFare__kPez4"};